import { SET_UPDATE_LANDING_PAGE_INFO } from '../actions/landing-page';
import DEFAULT_STATE, { LandingPageState } from '../defaults/landing-page';
import createReducer from './create-reducer';

function updateLandingPageData(
  state: LandingPageState,
  { payload }: { payload: LandingPageState },
) {
  return {
    ...state,
    ...payload,
  };
}

const handlers = {
  [SET_UPDATE_LANDING_PAGE_INFO]: updateLandingPageData,
};

export default createReducer(DEFAULT_STATE, handlers);
